
import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FormControl } from '@angular/forms';
import { MwcTableQueryParams } from 'mwc/table';
import { catchError, debounceTime, distinctUntilChanged, forkJoin, interval, map, Observable, of, Subject, switchMap, take, takeWhile, TimeoutError } from 'rxjs';
import { format } from 'date-fns';
import { GetCampaignOptions, GetMyCampaignsRequest, GetMyCampaignsResponse, campaignsListTableTabs } from '../../_shared/models/campaigns';
import { ArticleListTableTabs, ArticleStatus, FAQ, PUBLISHABLE_TEMPLATES, RESTORABLE_STATUSES } from 'src/app/_shared/consts/article-constants';
import { ArticleDetail, ArticleInfoDetail, BulkActionRequest, BulkActionResponse, DeleteFaq, DeleteFaqsRequest, ExportExcelRequest, ExportPDFRequest, FaqAnswer, FaqDetail, FaqImage, GetArticleByIdRequest, GetArticleByIdResponse, GetArticleByIdResponseType, GetArticleFaqsRequest, GetArticleFaqsResponse, GetArticleListRequest, GetArticleListResponse, GetArticlePublishContentDetailRequest, GetArticlePublishContentDetailResponse, GetSEOWidgetResponse, PublishAnswer, PublishArticleFaqsRequest, PublishFaq, PublishFaqCategory, PublishFaqDetail, PublishFaqSourceUrl, PublishFaqsResponse, SaveFaq, SaveFaqDetail, SaveFaqsRequest, ScheduleCancelRequest, ScheduleCancelResponse, Selector, UpdateArticleStatusRequest, UpdateArticleStatusResponse, UpdateWorkflowInstanceStatusRequest } from 'src/app/_shared/models/article';
import { ArticleStoreService } from 'src/app/services/article/article-store.service';
import { StorageHelper } from 'src/app/_utilities/storage-helper';
import { ArticleHelperService } from 'src/app/_shared/services/helper/article/article-helper.service';
import { NewTemplateHelperService } from 'src/app/_shared/services/helper/new-template-selector/new-template-helper.service';
import { ArticleService } from 'src/app/services/article/article.service';
import { MwcMessageService } from 'mwc/message';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { CommonService } from 'src/app/services/common/common.service';
import { UserInfo } from 'src/app/_shared/models/common';
import { FEATURES } from 'src/app/_shared/consts/app-constants';
import { MwcNotificationService } from 'mwc/notification';
import { GenerationInProgressHelperService } from '../../_shared/services/helper/generation-in-progress-popup/generation-in-progress-popup-helper.service';
import { DatePipe } from '@angular/common';
import { WebpageTemplateService } from '../../services/webpageTemplate/webpageTemplate.service';
import { GetProfileBrandsRequest, GetProfileBrandsResponse, ProfileBrand } from '../../_shared/models/webpage-template.model';

export class CampaignData {
  campaignId: string = '';
  CampaignTopic: string = '';
  createddate: string = '';
  brandVoiceId: number;
  targetAudienceId: number;
  goal: string;
  campaignGoal: string;
  keywords: string[];
  prompts: string[] = [];
  brandId: string = '';
  createdByName: string = '';
  urls: string = '';
  address?: string = '';
  telephoneNumber?: string = '';
}

@Component({
  selector: 'app-view-campaigns',
  templateUrl: './view-campaigns.component.html',
  styleUrls: ['./view-campaigns.component.scss'],
  providers: [DatePipe]
})
export class ViewCampaignsComponent implements OnInit,OnDestroy {
  @ViewChild('notificationTemplate') notificationTemplate!: TemplateRef<any>;
  @ViewChild('ErrorAlertTemplate') ErrorAlertTemplate!: TemplateRef<any>;
  searchSubject = new Subject<boolean>();
  campaignData: CampaignData = new CampaignData();
  _storageHelper: StorageHelper;
  campaignListData: ArticleDetail[] = [];
  filteredCampaignListData: ArticleDetail[] = [];
  totalRecords: number = 0;
  updateContentStatusRequest = new UpdateArticleStatusRequest();
  isRestoreTrashModalVisible = false;
  isTrashModalVisible = false;
  isDeleteModalVisible = false;
  isDraftModalVisible = false;
  isBulkTrashModalVisible = false;
  isBulkRestoreModalVisible = false;
  isBulkDeleteModalVisible = false;
  bulkDeleteCount = 0;
  isBulkPublishModalVisible = false;
  isBulkRevertModalVisible = false;
  countdown = 5;
  isButtonDisabled = true;
  private bulkTrackedArticleIds: number[] = [];
  lastPublishedStatus: number;
  dataToTrash: ArticleDetail;
  dataToDraft: ArticleDetail;
  listOfPostTableCols = new Map<string, {
    compare: any,
    sortOrder: string,
    sortDirections: string[],
    isSortable: boolean
  }>();
  isEditingCampaignTopic: boolean = false;
  originalCampaignTopic: string = '';
  CampaignDataListOfColumn = [
    {
      title: 'Title',
      key: 'title',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      visible: true
    },
    {
      title: '',
      key: '',
      isSortable: false,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      visible: true,
      width: '120px',
    },
    {
      title: 'Template',
      key: 'templateName',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '130px',
      visible: true
    },
    {
      title: 'Created By',
      key: 'createdbyname',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '150px',
      visible: true
    },
    {
      title: 'Created Date',
      key: 'createddate',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '130px',
      visible: true
    },
    {
      title: 'Status',
      key: 'status',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '140px',
      visible: true
    },
    {
      title: 'Score',
      key: 'seoScore',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '100px',
      align: "center",
      visible: true
    },
  ];

  CampaignDataListOfColumnWithoutStatus = [
    {
      title: 'Title',
      key: 'title',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      visible: true
    },
    {
      title: '',
      key: '',
      isSortable: false,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '120px',
      visible: true
    },
    {
      title: 'Template',
      key: 'templateName',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '140px',
      visible: true
    },
    {
      title: 'Created By',
      key: 'createdbyname',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '150px',
      visible: true
    },
    {
      title: 'Created On',
      key: 'createddate',
      isSortable: true,
      sortOrder: 'descend',
      sortDirections: ['ascend', 'descend'],
      width: '140px',
      visible: true
    },
    {
      title: 'Score',
      key: 'seoScore',
      isSortable: true,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      width: '130px',
      align: "center",
      visible: true
    },
  ];
  /*== hiding to maintain only global and common  seo check list and new list was updated in generation-in-progress-popup-helper service==*/
  /* seoAnalysisList: { title: string; desc?: string }[] = [
    { 'title': 'Focus on Quality Content', 'desc': 'Ensure your content is informative, engaging, and valuable to your audience' },
    { 'title': 'Optimize for Keywords', 'desc': 'Research and use relevant keywords naturally in your content to improve visibility' },
    { 'title': 'Use Descriptive URLs', 'desc': 'Make URLs descriptive, short, and keyword-rich to enhance understanding and SEO' },
    { 'title': 'Optimize Title Tags', 'desc': 'Include target keywords in title tags while making them compelling to click' },
    { 'title': 'Craft Compelling Meta Descriptions', 'desc': 'Write unique and enticing meta descriptions for each page to improve click-through rates.' },
    { 'title': 'Utilize Header Tags', 'desc': 'Structure your content with H1, H2, and H3 tags to improve readability and SEO.' },
    { 'title': 'Optimize Images', 'desc': 'Use descriptive filenames and alt text for images to improve accessibility and relevance.' },
    { 'title': 'Improve Site Speed', 'desc': 'Ensure your website loads quickly on all devices to reduce bounce rates and enhance user experience.' },
    { 'title': 'Mobile-Friendly Design', 'desc': 'Optimize your website for mobile users to cater to the increasing mobile traffic.' },
    { 'title': 'Secure Your Site with HTTPS', 'desc': 'Implement HTTPS to secure your site and boost its ranking signal.' },
    { 'title': 'Create Quality Backlinks', 'desc': 'Gain backlinks from reputable sites to enhance your site’s credibility and search ranking.' },
    { 'title': 'Use Social Media to Boost Visibility', 'desc': 'Share your content on social media platforms to increase traffic and engagement.' },
    { 'title': 'Implement Local SEO Practices', 'desc': 'Optimize your site for local search terms and listings to attract local customers.' },
    { 'title': 'Monitor Your Sites Performance', 'desc': 'Use tools like Google Analytics and Search Console to track traffic, performance, and issues.' },
    { 'title': 'Update Content Regularly', 'desc': 'Keep your site fresh with regular updates and new content to engage visitors and search engines.' },
    { 'title': 'Optimize for Voice Search', 'desc': 'Include conversational keywords and FAQs to capture voice search queries.' },
    { 'title': 'Use Internal Linking Wisely', 'desc': 'Create internal links to guide visitors to relevant content, improving site navigation and SEO.' },
    { 'title': 'Avoid Duplicate Content', 'desc': 'Ensure your content is unique across your site to avoid penalties from search engines.' },
    { 'title': 'Leverage Schema Markup', 'desc': 'Implement structured data to help search engines understand and display your content more prominently.' },
    { 'title': 'Stay Updated with SEO Practices', 'desc': 'SEO is ever-evolving; stay informed about the latest trends and algorithm updates to keep your site competitive.' }
  ]; */

  listTableTabs = ArticleListTableTabs;
  loading = true;
  radioValue = 'all';
  statusFormat = (percent: number): string => `${percent}`;
  /* Table */
  searchText: string = '';
  searchField: FormControl = new FormControl();
  orderBy: string = 'createddate';
  sortingOrder: string = 'desc';
  pageIndex: number = 1;
  pageSize: number = 10;
  initialLoading = 1;
  tableInitialLoading = 1;
  isDeleteConfirmPopup: boolean = false;
  deleteRecordIds: number = 0;
  campaignId: string = null;
  isCmsEnabled = false;
  isCmsBlogEnabled = false;
  isWorkflowEnabled = false;
  isSaasUser: boolean = false;
  mapOfExpandedData: { [articleId: number]: ArticleDetail[] } = {};
  errorMessage: string = '';  
  listOfArticle: ArticleDetail[];
  
  checked = false;
  indeterminate = false;
  setOfCheckedId: { articleId: number; status: number }[] = [];
  btnExportEnabled: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private ngChangeDetectorRef: ChangeDetectorRef,
    private router: Router,
    public articleStoreService: ArticleStoreService,
    public articleHelperService: ArticleHelperService,
    private newTemplateHelperService: NewTemplateHelperService,
    private articleService: ArticleService,
    private msg: MwcMessageService,
    private campaignService: CampaignService,
    private commonService: CommonService,
    private notification: MwcNotificationService,
    private generationInProgressHelperService: GenerationInProgressHelperService,
    private datePipe: DatePipe,
    private webpageTemplateService: WebpageTemplateService
  ) {
    this._storageHelper = new StorageHelper();
    this.setListOfColForPostTable();
  }

  ngOnDestroy(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
  ngOnInit(): void {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.fetchArticles();
    });

    this.campaignId = this.route.snapshot.queryParamMap.get("campaignId") || null;
    this.fetchCampaignDetail();
    this.commonService.getUserInfoValue().subscribe((res: UserInfo) => {
      if (res != null) {
        this.isSaasUser = res.isSaasUser;
      }
    });
    this.isCmsBlogEnabled = this._storageHelper.user.isCmsBlogEnabled;
    this.isCmsEnabled = this._storageHelper.user.isCmsEnabled;
    this.isWorkflowEnabled = this._storageHelper.user.isWorkflowEnabled;
  }

  isSpinning = false;
  fetchCampaignDetail() {
    let request = new GetMyCampaignsRequest();
    request.profileId = this._storageHelper.user.pId;
    request.pageNumber = 1;
    request.pageSize = 10;
    request.orderBy = 'createddate';
    request.sortingOrder = 'desc';
    request.search = '';
    request.campaignIds = [this.campaignId];
    request.status = "_all";
    this.isSpinning = true;

    this.campaignService.GetMyCampaigns<GetMyCampaignsResponse>(request).subscribe({
      next: (response) => {
        if (response && response.campaigns.length > 0) {
          let campaignData = new CampaignData();
          campaignData.address = response.campaigns[0].address;
          campaignData.telephoneNumber = response.campaigns[0].telephoneNumber;
          campaignData.urls = this.formatCampaignUrls(response.campaigns[0].urls);
          campaignData.createdByName = response.campaigns[0].createdByName;
          campaignData.brandId = response.campaigns[0].brandId;
          campaignData.campaignId = response.campaigns[0]._id;
          campaignData.CampaignTopic = response.campaigns[0].campaignName;
          campaignData.createddate = this.formatDateforBrandExport(response.campaigns[0].createdDate);
          campaignData.brandVoiceId = response.campaigns[0].brandVoiceId;
          campaignData.targetAudienceId = response.campaigns[0].targetAudienceId;
          campaignData.goal = response.campaigns[0].goal;
          campaignData.campaignGoal = response.campaigns[0].campaignGoal;
          campaignData.keywords = response.campaigns[0].keywords;
          campaignData.prompts = response.campaigns[0].prompts ?? [];
          this.campaignData = campaignData;
          if (campaignData.goal == 'Web Pages') {
            this.CampaignDataListOfColumnWithoutStatus = this.CampaignDataListOfColumnWithoutStatus.filter(s => s.title != 'Score');
            this.CampaignDataListOfColumn = this.CampaignDataListOfColumn.filter(s => s.title != 'Score');
          }

        } else {
          this.router.navigateByUrl("/campaigns/my-campaigns");
        }
        this.isSpinning = false;
        this.ngChangeDetectorRef.detectChanges();
      },
      error: (error) => {
        console.error('API Error:', error);
        this.isSpinning = false;
        this.router.navigateByUrl("/campaigns/my-campaigns");
      }
    });
  }

  private formatCampaignUrls(urls: string[] = []): string {
    if (!urls || urls.length === 0) {
      return '';
    }

    // If only one URL, return as it is
    if (urls.length === 1) {
      return urls[0];
    }

    const parsedUrls = urls.map((url) => {
      // Remove protocol if present
      const cleanUrl = url.replace(/^https?:\/\//, '');

      const parts = cleanUrl.split('/').filter(Boolean);

      return {
        original: cleanUrl,
        domain: parts[0] || '',
        brand: parts[1] || ''
      };
    });

    // Check if all domains are same
    const domains = [...new Set(parsedUrls.map((u) => u.domain))];

    if (domains.length === 1) {
      // Check brands
      const brands = [...new Set(parsedUrls.map((u) => u.brand))];

      // Same brand
      if (brands.length === 1 && brands[0]) {
        return `${domains[0]}/${brands[0]}`;
      }

      // Mixed brands
      return domains[0];
    }

    // Multiple domains
    return domains.join(', ');
  }


  formatDateforBrandExport(isoString) {
    const date = new Date(isoString);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return `${month}.${day}.${year}`;
  }

  formatDate(isoString) {
    const date = new Date(isoString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getUTCFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th'; // covers 11-20
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  }

  allCampaign() {
    this.router.navigateByUrl("/campaigns/my-campaigns");
  }

  initTemplate() {
    this.newTemplateHelperService.openTemplateSelector(null, null, this.campaignData);
  }

  postChange(event: any) {
    this.clearCheckedIds();
  }

  convertTreeToList(root: ArticleDetail): ArticleDetail[] {
    const stack: ArticleDetail[] = [];
    const array: ArticleDetail[] = [];
    const hashMap = {};
    stack.push({ ...root, expand: false });
    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.childArticles) {
        for (let i = node.childArticles.length - 1; i >= 0; i--) {
          stack.push({ ...node.childArticles[i], expand: false, parent: node });
        }
      }
    }
    return array;
  }

  visitNode(node: ArticleDetail, hashMap: { [articleId: number]: boolean }, array: ArticleDetail[]): void {
    if (!hashMap[node.articleId]) {
      hashMap[node.articleId] = true;
      array.push(node);
    }
  }

  getBlogListByType(type: ArticleListTableTabs) {
    this.stopArticleListPooling();
    this.loading = true;
    this.searchText = "";
    let request = new GetArticleListRequest();
    request.orderBy = "createddate";
    request.pageNumber = 1;
    request.pageSize = this.pageSize;
    request.sortingOrder = "desc";
    request.profileId = this._storageHelper.user.pId;
    let selectorValue = new Selector()
    let selectors = [];
    selectorValue.searchKey = ["title", "name"];
    selectorValue.searchValue = "";
    selectors.push(selectorValue);
    request.selectors = selectors;
    request.status = type;
    request.CampaignId = this.campaignId;
    this.articleHelperService.getListOfArticles((response: GetArticleListResponse) => {
      this.radioValue = type;
      if (response.articles && response.articles.length > 0) {
        response.articles.forEach((item, index) => {
          if (item.childArticles != null && item.childArticles.length > 0) {
            item.childArticles = item.childArticles;
          }
          else { item.childArticles = []; }
          this.mapOfExpandedData[item.articleId] = this.convertTreeToList(item);
        });
        this.campaignListData = response.articles;
        this.totalRecords = response.totalRecords;
        this.filteredCampaignListData = response.articles;
        this.loading = false;
        //if (response.articles.some(article => article.status === 6)) {
        //} else {
        //  this.stopArticleListPooling();
        //}
        this.resetCheckedIds();
        this.ngChangeDetectorRef.detectChanges();
      } else {
        this.campaignListData = [];
        this.filteredCampaignListData = []
        this.totalRecords = 0;
        this.loading = false;
        this.resetCheckedIds();
        this.ngChangeDetectorRef.detectChanges();
      }
      this.triggerArticleListPooling();
    }, request);
  }

  onSearch(searchTxt: string, pageIndex?: number, pageSize?: number): void {
    this.fetchArticles();
  }

  collapse(array: ArticleDetail[], data: ArticleDetail, $event: boolean): void {
    if (!$event) {
      if (data.childArticles) {
        data.childArticles.forEach(d => {
          const target = array.find(a => a.articleId === d.articleId)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  fetchArticles(): void {
    let request = new GetArticleListRequest();
    request.pageNumber = this.pageIndex;
    request.pageSize = this.pageSize;
    request.orderBy = this.orderBy;
    request.sortingOrder = this.sortingOrder;
    request.profileId = this._storageHelper.user.pId;
    request.status = this.radioValue == ArticleListTableTabs.ALL ? 'all' : this.radioValue;
    let selectorValue = new Selector();
    selectorValue.searchKey = ["title", "name"];
    selectorValue.searchValue = this.searchText;
    request.selectors = [selectorValue];
    request.CampaignId = this.campaignId;
    let isPollingActive = true;
    this.loading = true;
      this.articleHelperService.getListOfArticles((response: GetArticleListResponse) => {
        if (response.errorCode !== 1 && response.articles != null) {
          this.listOfArticle = [...response.articles];
          response.articles.forEach((item, index) => {
            if (item.childArticles != null && item.childArticles.length > 0) {
              item.childArticles = item.childArticles;
            }
            else { item.childArticles = []; }
            this.mapOfExpandedData[item.articleId] = this.convertTreeToList(item);
          });
          this.campaignListData = response.articles;
          this.totalRecords = response.totalRecords;
          this.filteredCampaignListData = response.articles;
          this.loading = false;
          this.ngChangeDetectorRef.detectChanges();

          isPollingActive = response.articles.some(article => article.status === 6);
          if (!isPollingActive) {
            this.stopArticleListPooling();
            if (this.bulkTrackedArticleIds.length > 0) {
              this.showBulkResults(response.articles);
            }
          }
          this.resetCheckedIds();
        } else {
          this.campaignListData = [];
          this.filteredCampaignListData = [];
          this.totalRecords = 0;
          this.loading = false;
          this.ngChangeDetectorRef.detectChanges();
          isPollingActive = false;
          this.stopArticleListPooling();
          this.resetCheckedIds();
        }
      }, request);
    this.triggerArticleListPooling();
  }

  poolInterval = 30000;
  timerId = null;

  triggerArticleListPooling() {
    if (this.timerId == null) {
      this.timerId = setInterval(() => {
        this.fetchArticles();
      }, this.poolInterval);
    }
  }

  stopArticleListPooling() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  getStatusColor(value: number) {
    if (value == null)
      return 'normal';

    switch (true) {
      case (value > 0 && value <= 50):
        return 'exception';
      case (value > 0 && value <= 74):
        return 'warning';
      case (value > 0 && value <= 100):
        return 'success';
      default:
        return 'normal';
    }
  }

  getStatus(value: number) {
    if (value == null)
      return 'gray';
    switch (true) {
      //case (value <=15):
      //  return 'exception';
      case (value == 1 || value == 5):
        return 'gray';
      case (value == 2):
        return 'success';
      case (value == 3):
        return 'warning';
      case (value == 9):
        return 'success';
      case (value == 8):
      case (value == 10):
        return 'error';
      default:
        return 'gray';
    }
  }

  getStatusText(data: any) {
    switch (data.status) {
      case 1: return 'Draft';
      case 5: return 'Scheduled';
      case 8: return 'Review';
      case 9: return 'Approved';
      case 10: return 'Revise';
      default: return 'Published';
    }
  }

  getDaysDifference(inputDate) {
    // Convert input date to a Date object
    const date = new Date(inputDate);
    // Get today's date
    const today = new Date();

    // Reset time components to compare only dates
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    // Calculate difference in milliseconds
    const timeDifference = Math.abs(today.getTime() - date.getTime());

    // Convert milliseconds to days
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    // Format the result
    if (daysDifference === 0) {
      return "Today";
    } else if (daysDifference === 1) {
      return "1 day ago";
    } else {
      return `${daysDifference} days ago`;
    }
  }

  //delete
  isDeletePopupOpen(ids) {
    this.deleteRecordIds = ids;
    this.isDeleteConfirmPopup = true;
  }
  cancelDeletePopup() {
    this.deleteRecordIds = 0;
    this.isDeleteConfirmPopup = false;
  }

  viewArticle(articleId) {
    let getArticlePublishContentDetailRequest = new GetArticlePublishContentDetailRequest();
    getArticlePublishContentDetailRequest.profileId = this._storageHelper.user.pId;
    getArticlePublishContentDetailRequest.articleId = articleId;
    this.articleService.getArticlePublishContentDetail<GetArticlePublishContentDetailRequest>(getArticlePublishContentDetailRequest).subscribe((response: GetArticlePublishContentDetailResponse) => {
      if (response.errorCode == 0) {
        let url = response.articlePublishContentDetail.publishedURL;
        const path = new URL(url).pathname.substring(1);
        window.open(this._storageHelper.user.cmsSiteUrl + path, '_blank');
      } else {
        this.notification.snackbarError(response.message);
      }
      // using angular change detection here because angular won't detect due to  callback
      this.ngChangeDetectorRef.detectChanges();
    }, (error) => {
      if (error instanceof TimeoutError) {
        this.notification.snackbarError(error.message + ". Please try again");
        this.ngChangeDetectorRef.detectChanges();
      } else {
        if (error && typeof error.error == "string") {
          this.notification.snackbarError(error.message);
        } else {
          (error.error.errors as string[]).forEach((item) => {
            this.notification.snackbarError(item);
          })
        }
        this.ngChangeDetectorRef.detectChanges();
      }
    });
  }

  revertTrashStatus(data: ArticleDetail) {
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.updateContentStatusRequest.actionName = "restore";
    this.updateContentStatusRequest.actionStatus = false;
    this.updateContentStatusRequest.articleDetail = [];
    let articleDetail = new ArticleInfoDetail();
    articleDetail.id = data.articleId;
    articleDetail.status = data.status;
    this.updateContentStatusRequest.articleDetail.push(articleDetail);
    this.updateContentStatusRequest.actionValue = ArticleStatus.RESTORED;
    this.updateContentStatusRequest.lastStatus = data.status;
    this.isRestoreTrashModalVisible = true;
    this.isTrashModalVisible = false;
    this.isDeleteModalVisible = false;
    this.lastPublishedStatus = data.status;
    this.ngChangeDetectorRef.detectChanges();
  }

  moveToTrashModal(data: ArticleDetail) {
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.updateContentStatusRequest.actionName = "trash";
    this.updateContentStatusRequest.actionStatus = true;
    this.updateContentStatusRequest.articleDetail = [];
    let articleDetail = new ArticleInfoDetail();
    articleDetail.id = data.articleId;
    articleDetail.status = data.status;
    this.updateContentStatusRequest.articleDetail.push(articleDetail);
    this.isTrashModalVisible = true;
    this.dataToTrash = data;
  }

  deleteBlog(data: any) {
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.updateContentStatusRequest.actionName = "delete";
    this.updateContentStatusRequest.actionStatus = true;
    this.updateContentStatusRequest.articleDetail = [];
    let articleDetail = new ArticleInfoDetail();
    articleDetail.id = data.articleId;
    articleDetail.status = data.status;
    this.updateContentStatusRequest.articleDetail.push(articleDetail);
    this.isDeleteModalVisible = true;
    this.isRestoreTrashModalVisible = false;
    this.isTrashModalVisible = false;
    this.updateContentStatusRequest.actionValue = ArticleStatus.DELETED;
  }

  trashModalHandleCancel(): void {
    this.isTrashModalVisible = false;
    this.isDeleteModalVisible = false;
    this.isRestoreTrashModalVisible = false;
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.dataToTrash = null;
  }

  trashModalHandleOk(): void {
    this.closeModals();
    const selectedArticles = this.getSelectedArticles(this.campaignListData);
    if (selectedArticles && selectedArticles.length > 0) {
      const existingIds = this.updateContentStatusRequest.articleDetail.map(detail => detail.id);
      selectedArticles.forEach(article => {
        if (!existingIds.includes(article.articleId)) {
          const articleDetail = new ArticleInfoDetail();
          articleDetail.id = article.articleId;
          articleDetail.status = article.status;
          this.updateContentStatusRequest.articleDetail.push(articleDetail);
        }
      });
      const deletedFaqIds = selectedArticles
        .map(item => {
          const ids = item.promptProperties?.deletedFaqIds;
          return ids ? JSON.parse(ids) : [];
        })
        .reduce((acc, val) => acc.concat(val), []);
      this.updateContentStatusRequest.deletedFaqIds = deletedFaqIds;
      // When trashing, recall (cancel) any in-progress moderation workflow so the article no
      // longer appears in Approval Management.
      if (this.updateContentStatusRequest.actionName === ArticleListTableTabs.TRASH) {
        this.recallWorkflowForArticles(selectedArticles);
      }
      this.updateBlogStatus(this.updateContentStatusRequest);
    }
  }

  // Recall (cancel) any active moderation workflow for the given articles via UpdateWorkflowStatus.
  private recallWorkflowForArticles(articles: any[]): void {
    if (!articles || articles.length === 0) {
      return;
    }
    articles.forEach(article => {
      const workflowInstanceId = article?.promptProperties?.workflowInstanceId;
      if (workflowInstanceId && Number(workflowInstanceId) > 0) {
        const request = new UpdateWorkflowInstanceStatusRequest();
        request.workflowInstanceId = Number(workflowInstanceId);
        request.action = "_cancelled";
        request.comments = "";
        this.articleService.UpdateWorkflowStatus(request).subscribe({
          next: () => { },
          error: (err) => console.error('Failed to recall workflow for trashed article', err)
        });
      }
    });
  }

  /**Draft Modal**/
  moveToDraftModal(data: ArticleDetail): void {
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.updateContentStatusRequest.actionName = "draft";
    this.updateContentStatusRequest.actionStatus = true;
    this.updateContentStatusRequest.articleDetail = [];
    let articleDetail = new ArticleInfoDetail();
    articleDetail.id = data.articleId;
    articleDetail.status = data.status;
    this.updateContentStatusRequest.articleDetail.push(articleDetail);
    this.isDraftModalVisible = true;
    this.dataToDraft = data;
    this.startCountdown();
  }

  startCountdown() {
    this.isButtonDisabled = true;
    this.countdown = 5;
    interval(1000)
      .pipe(take(6))
      .subscribe({
        next: (value) => {
          this.countdown = 5 - value;
          this.ngChangeDetectorRef.detectChanges();
        },
        complete: () => {
          this.isButtonDisabled = false;
          this.ngChangeDetectorRef.detectChanges();
        }
      });
  }

  draftModalHandleOk(): void {
    this.closeModals();
    const selectedArticles = this.getSelectedArticles(this.campaignListData);
    if (selectedArticles && selectedArticles.length > 0) {
      const existingIds = this.updateContentStatusRequest.articleDetail.map(detail => detail.id);
      selectedArticles.forEach(article => {
        if (!existingIds.includes(article.articleId)) {
          const articleDetail = new ArticleInfoDetail();
          articleDetail.id = article.articleId;
          articleDetail.status = article.status;
          this.updateContentStatusRequest.articleDetail.push(articleDetail);
        }
      });
      const deletedFaqIds = selectedArticles
        .map(item => {
          const ids = item.promptProperties?.deletedFaqIds;
          return ids ? JSON.parse(ids) : [];
        })
        .reduce((acc, val) => acc.concat(val), []);
      this.updateContentStatusRequest.deletedFaqIds = deletedFaqIds;
      this.updateBlogStatus(this.updateContentStatusRequest);
    }
  }

  draftModalHandleCancel(): void {
    this.isDraftModalVisible = false;
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.dataToDraft = null;
  }

  private closeModals(): void {
    this.isTrashModalVisible = false;
    this.isDeleteModalVisible = false;
    this.isRestoreTrashModalVisible = false;
    this.isDraftModalVisible = false;
  }

  updateBlogStatus(request: UpdateArticleStatusRequest, isBulkRestore: boolean = false) {
    request.profileId = this._storageHelper.user.pId;
    this.loading = true;
    this.articleService.updateArticleStatus<UpdateArticleStatusRequest>(request).subscribe((response: UpdateArticleStatusResponse) => {
      if (response.errorCode == 0) {
        if (isBulkRestore) {
          this.showBulkRestoreResult(request.articleDetail.length, response);
        }
        else if (request.actionName == ArticleListTableTabs.DELETE) {
          this.notification.snackbarSuccess('Article has been deleted successfully.');
        } else if (request.actionName == ArticleListTableTabs.TRASH && request.actionStatus) {
          this.notification.snackbarSuccess('Article(s) have been moved to trash successfully.');
        } else if (request.actionName == ArticleListTableTabs.DRAFT && request.actionStatus) {
          this.notification.snackbarSuccess('Your article has been restored as a Draft.');
        }
        else if (request.actionName == ArticleListTableTabs.RESTORE && !request.actionStatus && (request.lastStatus == ArticleStatus.DRAFT || request.lastStatus == ArticleStatus.PUBLISHED)) {
          this.notification.snackbarSuccess('Your article has been restored as a Draft.');
        }
        else if (request.actionName == ArticleListTableTabs.RESTORE && !request.actionStatus && request.lastStatus == ArticleStatus.SCHEDULED) {
          // A scheduled article is restored as a Draft (its scheduled publish was cancelled on trash).
          this.notification.snackbarSuccess('Your article has been restored as a Draft.');
        }
        // When a scheduled article is trashed or deleted, cancel its pending scheduled publish.
        if (request.actionName == ArticleListTableTabs.TRASH || request.actionName == ArticleListTableTabs.DELETE) {
          this.cancelScheduleForScheduledArticles(request);
        }
        this.getBlogListByType(this.radioValue == ArticleListTableTabs.ALL ? ArticleListTableTabs.ALL : ArticleListTableTabs.TRASH);
      } else {
        this.notification.snackbarError(response.message);
      }
      // using angular change detection here because angular won't detect due to  callback
      this.ngChangeDetectorRef.detectChanges();
      this.loading = false;
    }, (error) => {
      this.loading = false;
      if (error instanceof TimeoutError) {
        this.notification.snackbarError(error.message + ". Please try again");
        this.ngChangeDetectorRef.detectChanges();
      } else {
        if (error && error.error && error.error.message && typeof error.error.message == "string") {
          this.notification.snackbarError(error.error.message);
        } else {
          (error.error.errors as string[]).forEach((item) => {
            this.notification.snackbarError(item);
          })
        }
        this.ngChangeDetectorRef.detectChanges();
      }
      // A failed bulk restore may be because another user already restored the articles - reload so
      // the Trash tab shows what is actually still there.
      if (isBulkRestore) {
        this.getBlogListByType(ArticleListTableTabs.TRASH);
      }
    });
  }

  // Cancel the pending scheduled publish for any scheduled article being trashed/deleted so it
  // does not get published later. The backend resolves the sequence number from the content id.
  private cancelScheduleForScheduledArticles(request: UpdateArticleStatusRequest): void {
    if (!request?.articleDetail?.length) {
      return;
    }
    request.articleDetail
      .filter(detail => detail.status === ArticleStatus.SCHEDULED)
      .forEach(detail => {
        const cancelRequest = new ScheduleCancelRequest();
        cancelRequest.contentid = detail.id;
        cancelRequest.sequenceNumber = 0;
        this.articleService.SchedulePublishCancel<ScheduleCancelResponse>(cancelRequest).subscribe({
          next: () => { },
          error: (err) => console.error('Failed to cancel scheduled publish for trashed/deleted article', err)
        });
      });
  }

  flattenArticles(articles) {
    const flatList = [];
    const stack = [...articles];
    while (stack.length > 0) {
      const article = stack.pop();
      flatList.push(article);
      if (article.childArticles && article.childArticles.length > 0) {
        stack.push(...article.childArticles);
      }
    }
    return flatList;
  }

  private getSelectedArticles(list: any[]): any[] {
    const flatList = this.flattenArticles(list);
    if (
      this.updateContentStatusRequest &&
      this.updateContentStatusRequest.articleDetail &&
      this.updateContentStatusRequest.articleDetail.length > 0
    ) {
      return flatList.filter(article =>
        this.updateContentStatusRequest.articleDetail.some(
          detail =>
            detail.id === article.articleId
        )
      );
    }
  }

  private getArticleIdsByStatus(articles: any[], status: number): number[] {
    return articles.filter(article => article.status === status).map(article => article.articleId);
  }

  private getPublishedArticleSourceIds(articles: any[]): string[] {
    return articles.map(article => `${this._storageHelper.user.cmsSiteUrl}${article.module}${article.slugUrl}`);
  }

  private fetchArticleFaqs(draftArticleIds: number[], publishedArticleSourceIds: string[], isRestore: boolean): Observable<any> {
    return this.getArticleFaqs(draftArticleIds, publishedArticleSourceIds, isRestore);
  }

  getArticleFaqs(draftArticleIds: number[], publishedArticleSourceIds: string[], isDeletedRequired: boolean) {
    const getArticleFaqsRequest = new GetArticleFaqsRequest();
    getArticleFaqsRequest.articleId = draftArticleIds;
    getArticleFaqsRequest.sourceId = publishedArticleSourceIds;
    getArticleFaqsRequest.isDeletedRequired = isDeletedRequired;
    return this.articleService.GetArticleFaqs(getArticleFaqsRequest).pipe(
      switchMap((res: GetArticleFaqsResponse) => {
        if (res.errorCode !== 0 || !res.faqs || res.faqs.length === 0) {
          return of([]);
        }
        return of(res.faqs);
      })
    );
  }

  private isRestoreAction(): boolean {
    return this.updateContentStatusRequest.actionName === 'restore';
  }

  private getArticlesByStatus(articles: any[], status: number): any[] {
    return articles.filter(article => article.status === status);
  }

  private handleFaqs(faqs: any[]): void {
    if (!this.isRestoreAction()) {
      this.deleteFaqs(faqs);
    } else {
      this.restoreFaqs(faqs);
    }
  }

  private deleteFaqs(faqs: any[]): void {
    const deleteRequest = this.prepareFaqDeleteRequest(faqs);
    this.articleService.DeleteFaqs(deleteRequest).subscribe((deleteRes) => {
      if (deleteRes?.errorCode !== 0) {
        this.msg.error(deleteRes.errorMessage);
        this.ngChangeDetectorRef.detectChanges();
      }
      this.resetState();
    });
  }

  private restoreFaqs(faqs: any[]): void {
    const toBePublishedFaqs = faqs.filter(faq => faq.sourceId !== null);
    const toBeDraftedFaqs = faqs.filter(faq => faq.sourceId === null);

    if (toBePublishedFaqs.length > 0) {
      this.publishFaqs(toBePublishedFaqs);
    }

    if (toBeDraftedFaqs.length > 0) {
      this.saveDraftFaqs(toBeDraftedFaqs);
    }
    this.resetState();
  }

  private saveDraftFaqs(faqs: any[]): void {
    const draftFaqsRequest = this.prepareFaqRequest(faqs);
    this.articleService.SaveFaqs(draftFaqsRequest).subscribe((response) => {
      if (response?.errorCode !== 0) {
        this.msg.error(response.errorMessage);
        this.ngChangeDetectorRef.detectChanges();
      }
    });
  }

  prepareFaqRequest(faqDetails: FaqDetail[]): SaveFaqsRequest {
    const saveArticleFaqRequest = new SaveFaqsRequest();
    saveArticleFaqRequest.businessId = (Number)(this._storageHelper.user.bId);
    saveArticleFaqRequest.businessThingId = this._storageHelper.user.businessThingId;
    saveArticleFaqRequest.checkExist = false;
    saveArticleFaqRequest.faqs = this.faqObjectToSaveToFaqManager(faqDetails);
    return saveArticleFaqRequest;
  }

  faqObjectToSaveToFaqManager(faqDetails: FaqDetail[]) {
    let faqs = [];
    faqDetails.forEach(faqToSave => {
      const faq = new SaveFaq();
      const saveFaqDetail = this.getSaveFaqDetail(faqToSave);
      faq.faqDetail = saveFaqDetail;
      faqs.push(faq);
    });
    return faqs;
  }

  getSaveFaqDetail(faq: FaqDetail) {
    const saveFaqDetail = new SaveFaqDetail();
    saveFaqDetail.type = faq.type;
    saveFaqDetail.authorThingId = faq.authorThingId;
    saveFaqDetail.isStylizedText = faq.isStylizedText;
    saveFaqDetail.dataSource = faq.dataSource;
    saveFaqDetail.originDataSource = faq.originDataSource;
    saveFaqDetail.categories = faq.categories;
    saveFaqDetail.questionText = faq.questionText;
    saveFaqDetail.questionId = faq.questionId;
    saveFaqDetail.status = FAQ.Status.Draft;
    const faqAnswer = new FaqAnswer();
    faqAnswer.howToSteps = [];
    faqAnswer.text = faq.answer.text;
    const faqImage = new FaqImage();
    faqImage.url = faq.answer.image.url;
    faqImage.caption = faq.answer.image.caption;
    faqImage.width = '100';
    faqImage.height = '100';
    faqImage.isDAMImage = faq.answer.image.isDAMImage;
    faqAnswer.image = faqImage;
    saveFaqDetail.answer = faqAnswer;
    const parsedData = JSON.parse(faq.auxiliaryInfo);
    const transformedObject = parsedData.reduce((acc, item) => {
      acc[item.name] = item.value;
      return acc;
    }, {});
    saveFaqDetail.auxiliaryInfo = transformedObject;
    return saveFaqDetail;
  }

  private publishFaqs(faqs: any[]): void {
    const publishFaqsRequest = this.preparePublishFaqsRequest(faqs);
    this.articleService.PublishFaqs<PublishFaqsResponse>(publishFaqsRequest).subscribe((response) => {
      if (response?.errorCode !== 0) {
        this.msg.error(response.errorMessage);
        this.ngChangeDetectorRef.detectChanges();
      }
    });
  }

  preparePublishFaqsRequest(faqDetails: FaqDetail[]) {
    var publishFaqsRequest = new PublishArticleFaqsRequest();
    publishFaqsRequest.businessId = +this._storageHelper.user.bId;
    publishFaqsRequest.businessThingId = this._storageHelper.user.businessThingId;
    publishFaqsRequest.publishFaqs = [];
    var publishFaq = new PublishFaq();
    //var profileFaq = new FaqProfile();
    var sourceUrls: PublishFaqSourceUrl[] = [];
    var sourceUrl = new PublishFaqSourceUrl();
    sourceUrl.categories = [];
    var category = new PublishFaqCategory();
    var faqs: PublishFaqDetail[] = [];
    //TODO: create list of faqs
    faqDetails.forEach(faq => {
      var publishFaq = new PublishFaqDetail();
      publishFaq.faqId = faq.id;
      publishFaq.author = faq.author;
      publishFaq.authorPhotoUrl = "";
      publishFaq.authortype = faq.authorType;
      publishFaq.publisherUserThingId = faq.authorThingId;
      publishFaq.questionText = faq.questionText;
      publishFaq.questionId = 0;
      publishFaq.sourceId = faq.sourceId;
      publishFaq.status = FAQ.Status.SendToPublish;
      publishFaq.stylizedText = true;
      publishFaq.type = FAQ.Type.FAQ;
      publishFaq.categories = [FAQ.Category.None];
      publishFaq.answer = new PublishAnswer();
      publishFaq.answer.answerId = null;
      publishFaq.answer.sourceId = "Internal_Process";
      publishFaq.answer.answerText = faq.answer.text;
      publishFaq.answer.answerRichText = faq.answer.text;
      publishFaq.answer.image = faq.answer.image;
      publishFaq.answer.publisherUserThingId = faq.authorThingId;
      publishFaq.answer.author = faq.author;
      publishFaq.answer.authorPhotoUrl = "";
      publishFaq.answer.authortype = faq.authorType;;
      publishFaq.answer.howToQuestionAnswerContents = [];
      const parsedData = JSON.parse(faq.auxiliaryInfo);
      const transformedObject = parsedData.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      publishFaq.auxiliaryInfo = transformedObject;
      faqs.push(publishFaq);
    });
    category.categoryId = FAQ.Category.None;
    category.order = "0";
    category.faqs = faqs;
    sourceUrl.categories.push(category);
    sourceUrl.sourceId = faqDetails[0].sourceId;
    sourceUrls.push(sourceUrl);
    publishFaq.dataSourceId = this._storageHelper.user.isCmsEnabled ? FAQ.DataSource.WebsiteMs : FAQ.DataSource.WebsiteNonCms;
    publishFaq.faqs = null;
    publishFaq.profiles = [];
    publishFaq.sourceUrls = sourceUrls;
    publishFaq.profiles = null;
    publishFaqsRequest.publishFaqs.push(publishFaq);
    return publishFaqsRequest;
  }

  prepareFaqDeleteRequest(articleFaqs: FaqDetail[]): DeleteFaqsRequest {
    const deleteArticleFaqRequest = new DeleteFaqsRequest();
    deleteArticleFaqRequest.businessId = (Number)(this._storageHelper.user.bId);
    deleteArticleFaqRequest.businessThingId = this._storageHelper.user.businessThingId;
    let faqs = [];
    articleFaqs.forEach(faqRes => {
      if (faqRes.status === FAQ.Status.Draft) {
        const faq = new DeleteFaq();
        faq.questionId = faqRes.questionId;
        if (this.getArticleIdToDelete(faqRes).length > 0) {
          faq.auxId = this.getArticleIdToDelete(faqRes)[0];
        }
        faqs.push(faq);
      }
      else if (faqRes.status === FAQ.Status.Published) {
        const faq = new DeleteFaq();
        faq.questionId = faqRes.questionId;
        faq.faqLocations = [{ profileId: -1, sourceId: faqRes.sourceId }];
        faqs.push(faq);
      }

    });
    deleteArticleFaqRequest.faqs = faqs;
    return deleteArticleFaqRequest;
  }

  getArticleIdToDelete(faq: FaqDetail): number[] {
    const auxIds = this.getAuxIds(faq.auxiliaryInfo);
    const trashAuxIds = this.getTrashIds(faq.auxiliaryInfo);
    const remainingAuxIds = auxIds.filter(x => !trashAuxIds.includes(x));
    return this.updateContentStatusRequest.articleDetail.map(y => y.id).filter(y => remainingAuxIds.includes(y));
  }

  getAuxIds(auxiliaryInfo: string): number[] {
    return this.getIds(auxiliaryInfo, 'auxIds');
  }

  getIds(auxiliaryInfo: string, key: string): number[] {
    if (!auxiliaryInfo || auxiliaryInfo === 'null') return [];
    const infoArray = JSON.parse(auxiliaryInfo);
    const idsObj = infoArray.find(obj => obj.name === key);
    return idsObj ? idsObj.value : [];
  }

  getTrashIds(auxiliaryInfo: string): number[] {
    return this.getIds(auxiliaryInfo, 'trashAuxIds');
  }

  private resetState(): void {
    this.dataToTrash = null;
    this.dataToDraft = null;
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
  }

  onQueryParamsChange(params: MwcTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params;
    this.pageSize = pageSize;
    this.pageIndex = pageIndex;
    const currentSort = sort.find(item => item.value !== null && item.value !== undefined && item.value !== '' && item.key !== undefined && item.key !== '');
    const sortField = (currentSort && currentSort.key) || null;
    const sortOrder = (currentSort && currentSort.value) == 'ascend' ? 'asc' : 'desc';
    this.orderBy = sortField ? sortField : this.orderBy;
    this.sortingOrder = sortOrder;
    this.fetchArticles();
  }

  public setListOfColForPostTable() {

    this.listOfPostTableCols.set('Article', {
      compare: (a: ArticleDetail, b: ArticleDetail) => a.title?.localeCompare(b.title),
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      isSortable: true
    });
    this.listOfPostTableCols.set('Template', {
      compare: (a: ArticleDetail, b: ArticleDetail) => a.templateName?.localeCompare(b.templateName),
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      isSortable: true
    });
    this.listOfPostTableCols.set('Creator', {
      compare: (a: ArticleDetail, b: ArticleDetail) => a.createdbyname?.localeCompare(b.createdbyname),
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      isSortable: true
    });
    this.listOfPostTableCols.set('Date', {
      compare: (a: ArticleDetail, b: ArticleDetail) => a.createddate?.localeCompare(b.createddate),
      sortOrder: 'descend',
      sortDirections: ['ascend', 'descend'],
      isSortable: true
    });
    this.listOfPostTableCols.set('Category', {
      compare: (a: ArticleDetail, b: ArticleDetail) => a.categoryList.join(",")?.localeCompare(b.categoryList.join(",")),
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      isSortable: true
    });
    this.listOfPostTableCols.set('Score', {
      compare: (a: ArticleDetail, b: ArticleDetail) => a.seoScore - b.seoScore,
      sortOrder: '',
      sortDirections: ['ascend', 'descend'],
      isSortable: true
    });
  }

  openArticle(data: any, alldata: any) {
    const navigationExtras: any = {
      queryParams: {}
    };

    if (this.campaignData.campaignId) {
      navigationExtras.queryParams.campaignId = this.campaignData.campaignId;
      navigationExtras.queryParams.templateName = data.templateName;

    }
    if (alldata[0].articleId == data.articleId) {
      this.articleStoreService.updateIsParentArticle(true);
    } else {
      this.articleStoreService.updateIsParentArticle(false);
    }
    if (!data.parentArticleId) {
      this.router.navigate(['/manage-content/articles/create-detailed-post/edit', data.articleId], navigationExtras);
    } else {
      this.router.navigate(['/manage-content/articles/create-detailed-post/edit', data.parentArticleId], navigationExtras);
    }
  }

  renameCampaign() {
    this.isEditingCampaignTopic = true;
    this.originalCampaignTopic = this.campaignData.CampaignTopic?.trim() || '';
  }

  saveCampaignTopic() {
    const trimmedName = this.campaignData.CampaignTopic?.trim();
    if (!trimmedName) {
      this.notification.snackbarError('Campaign name cannot be blank.');
      this.campaignData.CampaignTopic = this.originalCampaignTopic;
      this.isEditingCampaignTopic = false;
      return;
    }
    this.campaignData.CampaignTopic = trimmedName;
    this.isEditingCampaignTopic = false;
    this.campaignService.RenameCampaign({ campaignId: this.campaignId, campaignNewName: this.campaignData.CampaignTopic })
      .subscribe({
        complete: () => {
          //this.notification.template(this.notificationTemplate, { mwcData: { msg: 'Campaign Renamed Successfully', errorType: 'success' }, mwcDuration: 5000, mwcStyle: { width: '400px', zIndex: 9999 }, mwcPlacement: 'topRight', mwcClass: 'mwc-success-notification-layout bg-success-2' });
          this.notification.snackbarSuccess('Campaign Renamed Successfully',{mwcStyle: { width: '400px', zIndex: 9999 }});
          this.ngChangeDetectorRef.detectChanges();
        },
        error: (err) => {
          this.errorMessage = "Campaign Rename failed.";
          //this.notification.template(this.ErrorAlertTemplate, { mwcDuration: 3000, mwcStyle: { padding: '16px' }, mwcPlacement: 'topRight', mwcClass: 'error-notification-content' });
          this.notification.snackbarError(this.errorMessage);
        }
      });
  }

  cancelEditing() {
    this.campaignData.CampaignTopic = this.originalCampaignTopic;
    this.isEditingCampaignTopic = false;
  }

  //table select row
  onAllChecked(checked: boolean): void {
    if (checked) {
      // Add all (skip in-progress articles); translation children follow their parent.
      this.filteredCampaignListData
        .filter(item => item.status !== ArticleStatus.INPROGRESS)
        .forEach(item => {
        this.updateCheckedSet(item.articleId, item.status, true);
        (item.childArticles ?? [])
          .filter(child => child.status !== ArticleStatus.INPROGRESS)
          .forEach(child => this.updateCheckedSet(child.articleId, child.status, true));
      });
    } else {
      // Remove all those items (including their translation children)
      this.filteredCampaignListData.forEach(item => {
        const idsToRemove = [item.articleId, ...(item.childArticles ?? []).map(child => child.articleId)];
        this.setOfCheckedId = this.setOfCheckedId.filter(
          obj => !idsToRemove.includes(obj.articleId)
        );
      });
    }
    this.checked = checked;
    this.indeterminate = false;
    this.btnExportCheck(this.setOfCheckedId);
  }
  updateCheckedSet(id: number, status: number, checked: boolean): void {
    if (checked) {
      // prevent duplicate entries for same id
      const exists = this.setOfCheckedId.some(obj => obj.articleId === id);      
      if (!exists) {
        this.setOfCheckedId.push({ articleId: id, status });        
      }
    } else {
      // remove by articleId
      this.setOfCheckedId = this.setOfCheckedId.filter(obj => obj.articleId !== id);      
    }
    this.btnExportCheck(this.setOfCheckedId);
  }

  resetCheckedIds() {
    this.setOfCheckedId = [];
    this.checked = false;
    //this.onAllChecked(false);
    this.indeterminate = false;
  }
  isSelected(id: number): boolean {
    return this.setOfCheckedId.some(obj => obj.articleId === id);
  }

  refreshCheckedStatus(): void {
    // true if every item in filtered list is in setOfCheckedId
    this.checked = this.filteredCampaignListData.every(item =>
      this.setOfCheckedId.some(obj => obj.articleId === item.articleId)
    );

    // true if some items are selected, but not all
    this.indeterminate =
      this.filteredCampaignListData.some(item =>
        this.setOfCheckedId.some(obj => obj.articleId === item.articleId)
      ) && !this.checked;
  }
  onItemChecked(id: number, status: number, checked: boolean): void {
    this.updateCheckedSet(id, status, checked);
    // Checking a parent selects its translation children by default (and
    // unchecking deselects them). Children can still be toggled individually
    // afterwards - relevant for reverting single translations to draft.
    const parent = (this.listOfArticle ?? []).find(article => article.articleId === id);
    (parent?.childArticles ?? [])
      .filter(child => child.status !== ArticleStatus.INPROGRESS)
      .forEach(child => this.updateCheckedSet(child.articleId, child.status, checked));
    this.refreshCheckedStatus();
  }

  //Bulk Publish / Bulk Revert to Draft
  // Ineligible selections are silently skipped by the backend; buttons show
  // whenever at least one selected article is eligible for the action.
  // Publish accepts parent article ids only - translation children are resolved
  // and published with their parent at the backend. The top-level list contains
  // parents only, so the lookup below also acts as the parent filter.
  private getSelectedParentArticles(): ArticleDetail[] {
    return (this.listOfArticle ?? [])
      .filter(article => this.setOfCheckedId.some(item => item.articleId === article.articleId));
  }

  // Selected parents (translation children cascade at the backend) plus
  // individually selected children whose parent is NOT selected - those are
  // actioned on their own.
  private getSelectedParentsAndOrphanChildren(): ArticleDetail[] {
    const parents = this.getSelectedParentArticles();
    const selectedParentIds = new Set(parents.map(parent => parent.articleId));
    const orphanChildren = (this.listOfArticle ?? [])
      .filter(parent => !selectedParentIds.has(parent.articleId))
      .reduce((selectedChildren: ArticleDetail[], parent) => selectedChildren.concat(
        (parent.childArticles ?? []).filter(child => this.setOfCheckedId.some(item => item.articleId === child.articleId))), []);
    return parents.concat(orphanChildren);
  }

  // Revert accepts selected parents (children cascade at the backend) plus
  // individually selected children whose parent is NOT selected - those are
  // reverted on their own.
  private getSelectedRevertArticles(): ArticleDetail[] {
    return this.getSelectedParentsAndOrphanChildren();
  }

  bulkPublishCount(): number {
    return this.getSelectedParentArticles()
      .filter(article => (article.status === ArticleStatus.DRAFT || article.status === ArticleStatus.PUBLISHED)
        && PUBLISHABLE_TEMPLATES.includes(article.templateName)).length;
  }

  bulkRevertCount(): number {
    return this.getSelectedRevertArticles()
      .filter(article => article.status === ArticleStatus.PUBLISHED).length;
  }

  // A Non-Moderator cannot publish — they submit articles for review from the editor instead.
  canBulkPublish(): boolean {
    if (this._storageHelper.isNonModerator) {
      return false;
    }
    return this.bulkPublishCount() > 0;
  }

  canBulkRevert(): boolean {
    return this.bulkRevertCount() > 0;
  }

  showBulkPublishModal(): void {
    this.isBulkPublishModalVisible = true;
    this.startCountdown();
  }

  showBulkRevertModal(): void {
    this.isBulkRevertModalVisible = true;
    this.startCountdown();
  }

  bulkModalHandleCancel(): void {
    this.isBulkPublishModalVisible = false;
    this.isBulkRevertModalVisible = false;
    this.isBulkRestoreModalVisible = false;
  }

  /**Bulk Restore from Trash**/
  // Same rule as the row level Restore icon: only top level rows can be restored. A selected parent
  // brings its trashed translations back with it (the backend resolves them), and a translation that
  // was trashed on its own is already a top level row. Statuses the restore procedure does not handle
  // (e.g. Failed / In Progress) are left out of the count and the request.
  private getSelectedRestoreArticles(): ArticleDetail[] {
    return this.getSelectedParentArticles()
      .filter(article => RESTORABLE_STATUSES.includes(article.status));
  }

  bulkRestoreCount(): number {
    return this.getSelectedRestoreArticles().length;
  }

  canBulkRestore(): boolean {
    return this.bulkRestoreCount() > 0;
  }

  showBulkRestoreModal(): void {
    this.isBulkRestoreModalVisible = true;
  }

  bulkRestoreHandleOk(): void {
    this.isBulkRestoreModalVisible = false;
    const articles = this.getSelectedRestoreArticles();
    if (articles.length === 0) {
      return;
    }
    const request = new UpdateArticleStatusRequest();
    request.actionName = "restore";
    request.actionStatus = false;
    request.actionValue = ArticleStatus.RESTORED;
    // Every restorable status comes back as Draft, so lastStatus no longer drives the restore itself.
    request.lastStatus = ArticleStatus.DRAFT;
    request.articleDetail = articles.map(article => {
      const articleDetail = new ArticleInfoDetail();
      articleDetail.id = article.articleId;
      articleDetail.status = article.status;
      articleDetail.geoRecommendationId = article.geoRecommendationId;
      return articleDetail;
    });
    // FAQs deleted before the article was trashed must stay deleted (the backend adds the translations' ids).
    request.deletedFaqIds = articles
      .map(item => {
        const ids = item.promptProperties?.deletedFaqIds;
        return ids ? JSON.parse(ids) : [];
      })
      .reduce((acc, val) => acc.concat(val), []);
    this.clearCheckedIds();
    this.updateBlogStatus(request, true);
  }

  private showBulkRestoreResult(requestedCount: number, response: UpdateArticleStatusResponse): void {
    const restoredCount = response.restoredArticleIds?.length ?? requestedCount;
    const skippedCount = response.skippedArticleIds?.length ?? 0;
    if (skippedCount > 0) {
      this.notification.snackbarError(`${restoredCount} of ${requestedCount} article(s) restored. ${skippedCount} could not be restored.`);
    } else {
      this.notification.snackbarSuccess(`${restoredCount} article(s) have been restored as Draft.`);
    }
  }

  bulkPublishHandleOk(): void {
    this.isBulkPublishModalVisible = false;
    const request = new BulkActionRequest();
    request.articleIds = this.getSelectedParentArticles().map(article => article.articleId);
    this.loading = true;
    this.articleService.bulkPublish(request).subscribe({
      next: (response: BulkActionResponse) => this.handleBulkQueueResponse(response, 'publishing'),
      error: (error) => this.handleBulkQueueError(error)
    });
  }

  bulkRevertHandleOk(): void {
    this.isBulkRevertModalVisible = false;
    const request = new BulkActionRequest();
    request.articleIds = this.getSelectedRevertArticles().map(article => article.articleId);
    this.loading = true;
    this.articleService.bulkRevertToDraft(request).subscribe({
      next: (response: BulkActionResponse) => this.handleBulkQueueResponse(response, 'revert to draft'),
      error: (error) => this.handleBulkQueueError(error)
    });
  }

  private handleBulkQueueResponse(response: BulkActionResponse, actionLabel: string): void {
    this.loading = false;
    if (response.errorCode == 0) {
      this.bulkTrackedArticleIds = [...(response.enqueuedArticleIds ?? [])];
      this.notification.snackbarSuccess(`${response.enqueuedArticleIds?.length ?? 0} article(s) queued for ${actionLabel}.`);
      if (response.skippedArticleIds?.length > 0) {
        this.notification.snackbarError(`${response.skippedArticleIds.length} article(s) were skipped as they are not eligible for this action.`);
      }
      this.clearCheckedIds();
      this.indeterminate = false;
      this.fetchArticles();
    } else {
      this.notification.snackbarError(response.message);
    }
    this.ngChangeDetectorRef.detectChanges();
  }

  private handleBulkQueueError(error: any): void {
    this.loading = false;
    if (error && error.error && error.error.message && typeof error.error.message == "string") {
      this.notification.snackbarError(error.error.message);
    } else {
      this.notification.snackbarError("Failed to queue the bulk action. Please try again.");
    }
    this.ngChangeDetectorRef.detectChanges();
  }

  private showBulkResults(articles: ArticleDetail[]): void {
    const tracked = articles.filter(article => this.bulkTrackedArticleIds.includes(article.articleId));
    const failedCount = tracked.filter(article => article.failureReason).length;
    this.bulkTrackedArticleIds = [];
    if (failedCount > 0) {
      this.notification.snackbarError(`${failedCount} article(s) could not be processed. Hover over the alert icon next to the article status for the reason.`);
    } else if (tracked.length > 0) {
      this.notification.snackbarSuccess("Bulk action completed successfully.");
    }
    this.ngChangeDetectorRef.detectChanges();
  }

  //bulk move To Trash Modal
  bulkmoveToTrashModal(){
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.updateContentStatusRequest.actionName = "trash";
    this.updateContentStatusRequest.actionStatus = true;
    this.updateContentStatusRequest.articleDetail = [];
    // Send parent ids only - translation children are trashed with their parent
    // at the backend. Passing a child explicitly detaches it from its parent, so
    // it would show up as its own top level row in the Trash tab instead of
    // staying grouped (this is what the row level "Move to Trash" already does).
    this.getSelectedParentsAndOrphanChildren().forEach(article => {
      let articleDetail = new ArticleInfoDetail();
      articleDetail.id = article.articleId;
      articleDetail.status = article.status;
      this.updateContentStatusRequest.articleDetail.push(articleDetail);
    });
    this.isBulkTrashModalVisible = true;
  }
  bulkTrashModalHandleCancel(){
    this.isBulkTrashModalVisible = false;
  }
  bulkTrashModalHandleOk(){
    const selectedArticles = this.getSelectedArticles(this.listOfArticle);
    if (selectedArticles && selectedArticles.length > 0) {
      const existingIds = this.updateContentStatusRequest.articleDetail.map(detail => detail.id);
      selectedArticles.forEach(article => {
        if (!existingIds.includes(article.articleId)) {
          const articleDetail = new ArticleInfoDetail();
          articleDetail.id = article.articleId;
          articleDetail.status = article.status;
          this.updateContentStatusRequest.articleDetail.push(articleDetail);
        }
      });
      const deletedFaqIds = selectedArticles
        .map(item => {
          const ids = item.promptProperties?.deletedFaqIds;
          return ids ? JSON.parse(ids) : [];
        })
        .reduce((acc, val) => acc.concat(val), []);
      this.updateContentStatusRequest.deletedFaqIds = deletedFaqIds;
      if (this.updateContentStatusRequest.actionName === ArticleListTableTabs.TRASH) {
        this.recallWorkflowForArticles(selectedArticles);
      }
      this.updateBlogStatus(this.updateContentStatusRequest);
      this.clearCheckedIds();
    }
    this.isBulkTrashModalVisible = false;
  }

  //bulk permanent delete modal
  bulkDeleteModal(){
    this.updateContentStatusRequest = new UpdateArticleStatusRequest();
    this.updateContentStatusRequest.actionName = "delete";
    this.updateContentStatusRequest.actionStatus = true;
    this.updateContentStatusRequest.articleDetail = [];
    const flatArticles = this.flattenArticles(this.listOfArticle);
    this.setOfCheckedId.forEach(item => {
      const article = flatArticles.find(article => article.articleId === item.articleId);
      if (article) {
        let articleDetail = new ArticleInfoDetail();
        articleDetail.id = article.articleId;
        articleDetail.status = article.status;
        this.updateContentStatusRequest.articleDetail.push(articleDetail);
      }
    });
    this.updateContentStatusRequest.actionValue = ArticleStatus.DELETED;
    this.bulkDeleteCount = this.setOfCheckedId.length;
    this.isBulkDeleteModalVisible = true;
  }
  bulkDeleteModalHandleCancel(){
    this.isBulkDeleteModalVisible = false;
  }
  bulkDeleteModalHandleOk(){
    const selectedArticles = this.getSelectedArticles(this.listOfArticle);
    if (selectedArticles && selectedArticles.length > 0) {
      const existingIds = this.updateContentStatusRequest.articleDetail.map(detail => detail.id);
      selectedArticles.forEach(article => {
        if (!existingIds.includes(article.articleId)) {
          const articleDetail = new ArticleInfoDetail();
          articleDetail.id = article.articleId;
          articleDetail.status = article.status;
          this.updateContentStatusRequest.articleDetail.push(articleDetail);
        }
      });
      const deletedFaqIds = selectedArticles
        .map(item => {
          const ids = item.promptProperties?.deletedFaqIds;
          return ids ? JSON.parse(ids) : [];
        })
        .reduce((acc, val) => acc.concat(val), []);
      this.updateContentStatusRequest.deletedFaqIds = deletedFaqIds;
      this.updateBlogStatus(this.updateContentStatusRequest);
      this.clearCheckedIds();
    }
    this.isBulkDeleteModalVisible = false;
  }

  private clearCheckedIds(): void {
    this.setOfCheckedId = [];
    this.checked = false;
    this.indeterminate = false;
  }

  //Export Functionalty Custom Template

  async exportAsExcel(fileName: string, articleIds: number[]) {
    var exportExcelRequest = new ExportExcelRequest();
    exportExcelRequest.articleIds = articleIds;
    this.articleService.exportExcel(exportExcelRequest).subscribe(
      (file) => {
        this.generationInProgressHelperService.closeTemplateSelector();
        this.ngChangeDetectorRef.detectChanges();
        let contentType = 'application/excel';
        let blob = new Blob([file], { type: contentType });

        let dateNow = new Date();
        var month = dateNow.toLocaleString('en-us', { month: 'long' });

        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      (error) => {
        this.generationInProgressHelperService.closeTemplateSelector();
        this.ngChangeDetectorRef.detectChanges();
      },
      () => { }
    );
  }

  async exportAsPDF(html: string, fileName: string, languages:string[]) {
    // Create hidden container
    const container = document.createElement('div');
    container.id = 'article-html';
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.width = '794px'; // roughly A4 width in px @96dpi
    document.body.appendChild(container);
    container.innerHTML = html;
    var exportPDFRequest = new ExportPDFRequest();
    exportPDFRequest.html = html; 
    exportPDFRequest.language = languages;
    exportPDFRequest.marginTop = 20;
    exportPDFRequest.marginBottom = 20;
    exportPDFRequest.marginLeft = 20;
    exportPDFRequest.marginRight = 20;
    this.articleService.exportPDF(exportPDFRequest).subscribe(
      (file) => {
        this.generationInProgressHelperService.closeTemplateSelector();
        this.ngChangeDetectorRef.detectChanges();
        let contentType = 'application/pdf';
        let blob = new Blob([file], { type: contentType });

        let dateNow = new Date();
        var month = dateNow.toLocaleString('en-us', { month: 'long' });

        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      (error) => {
        this.generationInProgressHelperService.closeTemplateSelector();
        this.ngChangeDetectorRef.detectChanges();
      },
      () => { }
    );
  }

  async exportAsDOC(html: string, fileName: string) {

    // Create HTML content with proper styling
    var htmlContent: string = `
  <html xmlns:o='urn:schemas-microsoft-com:office:office'
        xmlns:w='urn:schemas-microsoft-com:office:word'
        xmlns='http://www.w3.org/TR/REC-html40'>
    <head>
      <title>${fileName}</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; }
        h1, h2, h3 { color: #333; }
        img { max-width: 100%; height: auto; }
      </style>
    </head>
    <body>
      ${html}
    </body>
  </html>
`;
    htmlContent = htmlContent.replace(/<table>/g, "<table style='border:solid 1px;' cellspacing='0' cellpadding='5'>")
      .replace(/<td>/g, "<td style='border:solid 1px;'>")
      .replace(/<th>/g, "<th style='border:solid 1px;'>");

    // Create Blob and download
    const blob = new Blob(['\ufeff', htmlContent], {
      type: 'application/msword'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName.replace(/ /g, '_') + '.doc';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    this.generationInProgressHelperService.closeTemplateSelector();
  }

  private async getHtmlTemplate(ishtmlExport: boolean = true, isDocExport: boolean = false, useBase64: boolean = false, data: GetArticleByIdResponseType = null): Promise<string> {
    let html = "";
    if (data && data.article) {
      let image = ``;
      let imgSrc = (((data.article.damImage && data.article.damImage.damAssetInfo) && (data.article.damImage.damAssetInfo["originalUrl"] || data.article.damImage.damAssetInfo["OriginalUrl"])) ?
        (data.article.damImage.damAssetInfo["originalUrl"] ? data.article.damImage.damAssetInfo["originalUrl"] :
          data.article.damImage.damAssetInfo["OriginalUrl"])
        : "");
      let faqs = ``;
      if (data.article.faqs != null) {
        var faqList = data.article.faqs.filter(faq => {
          // Check if either isNewlyAdded or isEdited property is true for the current faq object
          return faq.isDeleted === false || faq.isDeleted === undefined || faq.isDeleted === null;
        });
        faqs += `<h1>FAQs</h1><div class="content">`;

        for (const faq of faqList) {
          let imgTag = '';

          if (faq.faqDetail.answer?.image?.url) {
            const imageUrl = (isDocExport)
              ? await this.ensureImageDimensions(faq.faqDetail.answer.image.url, 'faq', useBase64)
              : faq.faqDetail.answer.image.url;

            imgTag = `
      <img src="${imageUrl}" alt="FAQ Image"
           style="width: 100px; height: auto; margin-right: 15px; object-fit: contain;" />
    `;
          }

          faqs += `
    <div class="faq-item" style="display: flex; align-items: flex-start; margin-bottom: 20px;">
      ${imgTag}
      <div>
        <h3 style="margin: 0 0 10px 0;">${faq.faqDetail.questionText}</h3>
        <p style="margin: 0;">${faq.faqDetail.answer.text}</p>
      </div>
    </div>
  `;
        }

        faqs += `</div>`;

        if (faqList.length == 0) {
          faqs = ``;
        }
      }
      let details = ``;
      let detailsHTML = '<section class="details">';
      const mapping: { [key: string]: string } = {
        metaTitle: "Meta Title",
        metaDescription: "Meta Description",
        //tags: "Tags",
        tagsList: "Tags",
        //multipleCategoryname: "Category",
        categoryList: "Category",
        image: "Featured Image (URL)",
        imageAltText: "Alt Tag",
        keyPhrase: "Key Phrase",
        snippet: "Excerpt Summary",
        slugUrl: "URL Slug",
        authorBiolink: "Author Bio Link",
        authorName: "Author Name"
      };
      let keys = ['metaTitle', 'metaDescription', 'categoryList', 'tagsList', 'image', 'imageAltText', 'keyPhrase', 'snippet', 'slugUrl', 'authorName', 'authorBiolink'];
      for (let [key, value] of Object.entries(data.article)) {
        //if (!data.article.isPublishable) {
        //  if (key !== "categoryList") {
        //    continue;
        //  }
        //}
        if (keys.includes(key)) {
          //if (key == "categoryList") {
          //  if (this.categories.length > 0 && this.selectedCategories.length > 0)
          //    value = this.categories.filter(s => this.selectedCategories.includes(s.categoryId.toString())).map(s => s.categoryName);
          //}
          //if (key == "imageAltText" || key == "authorBiolink" || key == "authorName") {            
          //  value = (key == "imageAltText") ? "altTag" : key;            
          //}
          if (value == null || value == undefined) value = "";
          detailsHTML += `
      <div class="detail-item" style="margin:0;padding:0;margin-bottom:16px;">
        <span class="detail-key">${mapping[key]}:</span>
        <span class="detail-value">${key == "image" ? imgSrc : value}</span>
      </div>`;
        }
      }

      details = `
  <h1>Meta Details</h1>
  <div class="content" style="margin:0;padding:0;margin-bottom:16px;">
      ${detailsHTML}
  </div>
`;

      if (isDocExport && imgSrc) {
        imgSrc = await this.ensureImageDimensions(imgSrc, "body", useBase64);
      }

      image = `<img src="${imgSrc}"
      alt="${data.article.imageAltText != undefined ? data.article.imageAltText : ""}">`;
      if (imgSrc == "") image = ``;

      html = `<!DOCTYPE HTML>
          <html lang="en">
          <head>
            <meta charset="utf-8">
            <meta name="MobileOptimized" content="320">
            <meta name="viewport" content="width=device-width, target-densitydpi=160dpi, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0">
            <title>${data.article.title}</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <meta name="ROBOTS" content="NOARCHIVE">
            <meta name="title" content="${data.article.metaTitle}">
            <meta name="description" content="${data.article.metaDescription}">
          </head>
          <body>
          ${image}
            <h1>${data.article.title}</h1>
            <div class="content">${data.article.content}</div>
            ${faqs}
            ${ishtmlExport ? details : ""}
          </body>
          </html>`;
    }
    else {
      html = `<!DOCTYPE HTML>
            <html lang="en">
            <body>
            <h1> No Data </h1>
            </body>
            </html>`;
    }
    return html;
  }

  getRandomItems = (list: any[], count: number): any[] => {
    const shuffled = list.sort(() => 0.5 - Math.random()); // Shuffle the list
    return shuffled.slice(0, count); // Return the first `count` items
  };  

  async ensureImageDimensions(imageUrl: string, imageType: string, useBase64: boolean = false): Promise<string> {
    // Check if URL already has query parameters
    if (imageUrl.includes('?')) {
      const url = new URL(imageUrl);
      const params = new URLSearchParams(url.search);
      if (imageType == "faq") {
        params.set('width', '300');
        params.set('height', '300');
      }
      else {
        params.set('width', '500');
        params.set('height', '300');
      }
      url.search = params.toString();
      if (useBase64) return this.convertBase64ToPNG(await this.imageUrlToBase64(url.toString()));
      return url.toString();
    } else {
      // Add query parameters if none exist
      if (imageType == "faq") {
        if (useBase64) return this.convertBase64ToPNG(await this.imageUrlToBase64(`${imageUrl}?width=300&height=300`));
        return `${imageUrl}?width=300&height=300`;
      }
      else {
        if (useBase64) return this.convertBase64ToPNG(await this.imageUrlToBase64(`${imageUrl}?width=500&height=300`));
        return `${imageUrl}?width=500&height=300`;
      }
    }
  }

  convertBase64ToPNG(base64Image: string) {
    return base64Image.replace(/(?<=image\/).*?(?=;)/, "png");
  }

  private async imageUrlToBase64(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  btnExportCheck(selectedIds:any) {
    const selectedArticleIds = selectedIds
      .filter(item => item.status === 1)
      .map(item => item.articleId);

    if (selectedArticleIds.length === 0) {
      this.btnExportEnabled = false;
    }
    else {
      this.btnExportEnabled = true;      
    }    
  }


  exportByType(exportType: string) {
    const selectedArticleIds = this.setOfCheckedId
      .filter(item => item.status === 1)
      .map(item => item.articleId);

    if (selectedArticleIds.length === 0) {
      this.btnExportEnabled = false;
    }
    else {
      this.btnExportEnabled = true;
      if (exportType == 'pdf') {
        this.generationInProgressHelperService.openWaitingPopup(this.getRandomItems([], 3), 'Generating PDF...');
      }
      else if (exportType == 'docx') {
        this.generationInProgressHelperService.openWaitingPopup(this.getRandomItems([], 3), 'Generating DOCX...');
      }
      else if (exportType == 'excel') {
        this.generationInProgressHelperService.openWaitingPopup(this.getRandomItems([], 3), 'Generating Excel...');
      }
      this.exportSelectedArticles(selectedArticleIds, exportType);      
    }    
  }
  exportSelectedArticles(articleIds: number[], exportType:string) {
    if (exportType === 'excel') {
      this.exportAsExcel('ExcelExport.xlsx', articleIds);
      return;
    }
    const profileBrandRequest: GetProfileBrandsRequest = {
      brandId: this.campaignData.brandId,
      profileId: this._storageHelper.user.pId
    };
    this.webpageTemplateService.GetProfileBrands(profileBrandRequest)
      .pipe(
        catchError(() => of({ brands: [] } as unknown as GetProfileBrandsResponse)),
        switchMap((brandRes: GetProfileBrandsResponse) => {
          const brand: ProfileBrand | null = (brandRes?.brands && brandRes.brands.length > 0)
            ? brandRes.brands[0]
            : null;
          const articleRequests = articleIds.map(articleId => {
            const req = new GetArticleByIdRequest();
            req.articleId = articleId;
            req.profileId = this._storageHelper.user.pId;
            return this.articleService.getArticleById<GetArticleByIdResponse>(req).pipe(
              map(async (response) => {
                if (response.errorCode === 0) {
                  const html = await this.getHtmlTemplate(true, true, true, response);
                  const language: string = response.article.language;
                  return { html, language, templateId: response.article.templateId };
                }
                return { html: '', language: null, templateId: 0 };
              })
            );
          });
          return forkJoin(articleRequests).pipe(map(results => ({ brand, results })));
        })
      )
      .subscribe(async ({ brand, results }) => {
        const resolvedResults = await Promise.all(results);

        const htmlChunks = resolvedResults.map(r => r.html);
        const combinedBodyHtml = this.combinedHtml(htmlChunks);
        // Brand details header applies only to webpages (templateId 32), not to campaign-created content.
        const isWebpageExport = resolvedResults.length > 0 && resolvedResults.every(r => r.templateId === 32);
        const header = isWebpageExport ? this.buildBrandHeaderHtml(brand, exportType) : '';
        const footer = isWebpageExport ? this.buildDisclaimerHtml(exportType) : '';
        const finalHtml = this.buildExportDocument(header + combinedBodyHtml + footer);

        const uniqueLanguages = Array.from(new Set(resolvedResults.map(r => r.language).filter(Boolean)));
        if (exportType == 'pdf') {
          this.exportAsPDF(finalHtml, 'PdfExport.pdf', uniqueLanguages);
        }
        else if (exportType == 'docx') {
          this.exportAsDOC(finalHtml, 'DocExport.doc');
        }
      });
  }

  private buildBrandHeaderHtml(brand: ProfileBrand | null, exportType: string = 'pdf'): string {
    const safe = (v: any) => (v == null ? '' : String(v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;'));
    
    // Word's HTML renderer ignores max-width/max-height on <img>, falling back to the image's
    // intrinsic size - so both branches use an explicit width instead of a max-width/max-height
    // ceiling. Using max-* for PDF only would leave small logos tiny there while docx (forced to
    // an explicit width) renders the same logo much larger, so both are pinned to the same size.
    const logoImg = brand?.logo
      ? exportType === 'docx'
        ? `<img src="${brand.logo}" alt="Logo" width="150" style="width:150px;">`
        : `<img src="${brand.logo}" alt="Logo" width="180" style="width:180px;display:block;margin-bottom:8px;">`
      : '';
    const brandName = safe(brand?.name);
    const address = safe(this.campaignData?.address);
    const telephone = safe(this.campaignData?.telephoneNumber);
    const createdBy = safe(this.campaignData.createdByName ? this.campaignData.createdByName : this._storageHelper.user?.userName);
    const dateStr = this.campaignData.createddate;
    const website = this.campaignData.urls;

    // For Word documents, use table-based layout with Unicode icons (SVG not supported well in Word)
    if (exportType === 'docx') {
      return `
      <table style="width:100%;table-layout:fixed;border-collapse:collapse;margin-bottom:32px;border:1px solid #e0e0e0;background-color:#ffffff;">
        <tr>
          <td width="200" style="border:1px solid #e0e0e0;border-right:0;padding:24px;width:200px;vertical-align:middle;text-align:center;">
            ${logoImg}
          </td>
          <td style="border:1px solid #e0e0e0;border-left:0;padding:24px;vertical-align:top;">
            <h2 style="margin:0 0 16px 0;font-size:28px;font-weight:bold;color:#1a1a1a;text-transform: uppercase;word-break:break-all;">
              ${brandName}
            </h2>
            <table border="0" style="width:100%;border-collapse:collapse;font-size:14px;color:#363636;">
              <tr>
                <td colspan="3" style="border:none;padding:8px 0;vertical-align:top;">
                  <div style="font-weight:bold;margin-bottom:2px;color:#363636">Address</div>
                  <div style="font-size:13px;">${address ? address : 'N/A'}</div>
                </td>
              </tr>
              <tr>
                <td style="border:none;padding:8px 0;width:33%;vertical-align:top;">
                  <div style="font-weight:bold;margin-bottom:2px;color:#363636">Phone</div>
                  <div style="font-size:13px;">${telephone}</div>
                </td>
                <td style="border:none;padding:8px 12px;width:33%;vertical-align:top;">
                  <div style="font-weight:bold;margin-bottom:2px;color:#363636">Created</div>
                  <div style="font-size:13px;">${dateStr ? dateStr : 'N/A'}</div>
                </td>
                <td style="border:none;padding:8px 0 8px 12px;width:34%;vertical-align:top;">
                  <div style="font-weight:bold;margin-bottom:2px;">Author</div>
                  <div style="font-size:13px;">${createdBy}</div>
                </td>
              </tr>
            </table>
            ${website ? `
            <div style="padding-top:10px;margin-top:10px;font-size:14px;display:flex;align-items:center;">
              <div style="font-weight:bold;margin-right:4px;color:#363636">Website:</div>
              <div style="word-break:break-all;">
                <a href="${website ? website : '#'}" style="color:#0066cc;text-decoration:none;font-size:12px;">${website ? website : 'N/A'}</a>
              </div>
            </div>
            ` : ''}
          </td>
        </tr>
      </table>
      `;
    }

    // For PDF, use flexbox layout with icons (better visual design)
    return `
    <div style="background-color:#ffffff;border:1px solid #e0e0e0;border-radius:4px;padding:24px;margin-bottom:32px;font-family:Arial,sans-serif;">
      <div style="display:flex;gap:32px;margin-bottom:24px;">
        <div style="flex: 0 0 250px;align-items: center;display: flex;justify-content: center;">
          ${logoImg}
        </div>
        <div style="flex:1;">
          <h2 style="margin:0 0 16px 0;font-size:34px;font-weight:bold;color:#1a1a1a;    text-transform: uppercase;word-break:break-all;">
            ${brandName}
          </h2>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;font-size:16px;color:#363636;">
            <div style="display:flex;row-gap:8px;margin-bottom:10px;align-items: flex-start">
              <div style="display:flex;align-items: flex-start;margin-right:32px;flex:1 1 auto;max-width:300px;min-width:0;">
                <span style="display:flex;width:25px;height:25px;margin-right:8px;flex-shrink:0;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
                    <path d="M7.99935 8.66667C9.10392 8.66667 9.99935 7.77124 9.99935 6.66667C9.99935 5.5621 9.10392 4.66667 7.99935 4.66667C6.89478 4.66667 5.99935 5.5621 5.99935 6.66667C5.99935 7.77124 6.89478 8.66667 7.99935 8.66667Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.99935 14.6667C10.666 12 13.3327 9.61218 13.3327 6.66667C13.3327 3.72115 10.9449 1.33333 7.99935 1.33333C5.05383 1.33333 2.66602 3.72115 2.66602 6.66667C2.66602 9.61218 5.33268 12 7.99935 14.6667Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
                <div style="font-size:16px;word-break:break-word;">${address ? address : 'N/A'}</div>
              </div>
              <div style="display:flex;align-items: center;flex-shrink:0;min-width:180px">
                <span style="display:flex;width:25px;height:25px;margin-right:8px;flex-shrink:0;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                    <path d="M8.38028 8.85335C9.07627 10.303 10.0251 11.6616 11.2266 12.8632C12.4282 14.0648 13.7869 15.0136 15.2365 15.7096C15.3612 15.7694 15.4235 15.7994 15.5024 15.8224C15.7828 15.9041 16.127 15.8454 16.3644 15.6754C16.4313 15.6275 16.4884 15.5704 16.6027 15.4561C16.9523 15.1064 17.1271 14.9316 17.3029 14.8174C17.9658 14.3864 18.8204 14.3864 19.4833 14.8174C19.6591 14.9316 19.8339 15.1064 20.1835 15.4561L20.3783 15.6509C20.9098 16.1824 21.1755 16.4481 21.3198 16.7335C21.6069 17.301 21.6069 17.9713 21.3198 18.5389C21.1755 18.8242 20.9098 19.09 20.3783 19.6214L20.2207 19.779C19.6911 20.3087 19.4263 20.5735 19.0662 20.7757C18.6667 21.0001 18.0462 21.1615 17.588 21.1601C17.1751 21.1589 16.8928 21.0788 16.3284 20.9186C13.295 20.0576 10.4326 18.4332 8.04466 16.0452C5.65668 13.6572 4.03221 10.7948 3.17124 7.76144C3.01103 7.19699 2.93092 6.91477 2.9297 6.50182C2.92833 6.0436 3.08969 5.42311 3.31411 5.0236C3.51636 4.66357 3.78117 4.39876 4.3108 3.86913L4.46843 3.7115C4.99987 3.18006 5.2656 2.91433 5.55098 2.76999C6.11854 2.48292 6.7888 2.48292 7.35636 2.76999C7.64174 2.91433 7.90747 3.18006 8.43891 3.7115L8.63378 3.90637C8.98338 4.25597 9.15819 4.43078 9.27247 4.60655C9.70347 5.26945 9.70347 6.12403 9.27247 6.78692C9.15819 6.96269 8.98338 7.1375 8.63378 7.4871C8.51947 7.60142 8.46231 7.65857 8.41447 7.72538C8.24446 7.96281 8.18576 8.30707 8.26748 8.58743C8.29048 8.66632 8.32041 8.72866 8.38028 8.85335Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <div style="font-size:16px;white-space:nowrap;">${telephone ? telephone : 'N/A'}</div>
              </div>
            </div>
            <div style="display:flex;margin-bottom:10px">
              <div style="display:flex;align-items: center;margin-right:32px;">
                <span style="display:flex;width:25px;height:25px;margin-right:8px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                    <path d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <div style="display:flex;gap:4px;align-items: center;font-size:16px;"><span style="font-weight: bold;margin-right:4px;font-size:16px">Created: </span> ${dateStr ? dateStr : 'N/A'}</div>
              </div>
              <div style="display:flex;align-items: center;">
                <span style="display:flex;width:25px;height:25px;margin-right:8px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                    <path d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <div style="display:flex;gap:4px;align-items: center;font-size:16px;"><span style="font-weight: bold;margin-right:4px;font-size:16px">By: </span>${createdBy ? createdBy : 'N/A'}</div>
              </div>
            </div>
            ${website ? `
            <div style="display:flex;gap:8px;align-items: flex-start;">
              <span style="display:flex;width:25px;height:25px;margin-right:8px;flex-shrink:0;">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                  <path
                  d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22M2.50002 9H21.5M2.5 15H21.5"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <div style="min-width:0;word-break:break-all;"><a href="${website ? website : '#'}" style="color:#0066cc;text-decoration:none;font-size:16px;word-break:break-all;">${website ? website : 'N/A'}</a></div>
            </div>
            ` : ''}
          </div>
        </div>
      </div>
    </div>
    `;
  }

  private buildDisclaimerHtml(exportType: string = 'pdf'): string {
    // For Word documents, use simpler styling without border-radius
    if (exportType === 'docx') {
      return `
<table style="width:100%;border-collapse:collapse;border:1px solid #e0e0e0;background-color:#f5f5f5;">
  <tr>
    <td style="border:1px solid #e0e0e0;padding:16px;font-family:Arial,sans-serif;font-size:12px;color:#333;">
      <div style="font-weight:bold;margin:0;padding:0;margin-bottom:8px;color:#1a1a1a;font-size:13px;line-height:normal">Disclaimer:</div>
      <div>This communication may contain confidential and private information intended solely for the designated recipient. Any unauthorized access, use, disclosure, or distribution is strictly prohibited. If you have received this in error, please notify the sender immediately and delete all copies.</div>
    </td>
  </tr>
</table>
`;
    }

    // For PDF, use modern card styling with rounded corners
    return `
<div style="background-color:#f5f5f5;border:1px solid #e0e0e0;border-radius:4px;padding:16px;margin-top:32px;font-family:Arial,sans-serif;font-size:12px;line-height:1.6;color:#333;">
  <strong style="display:block;margin:0;margin-bottom:8px;color:#1a1a1a;">Disclaimer:</strong>
  <p style="margin:0;">This communication may contain confidential and private information intended solely for the designated recipient. Any unauthorized access, use, disclosure, or distribution is strictly prohibited. If you have received this in error, please notify the sender immediately and delete all copies.</p>
</div>
`;
  }

  private buildExportDocument(innerHtml: string): string {
    // Article content can carry its own inline font-family (e.g. leftover from how it was
    // authored/pasted), which overrides the body-level font below and produces mismatched
    // fonts across the exported PDF/DOC. Stripping it here keeps the whole document on one font.
    const cleanedHtml = this.removeFontFamilyFromHtml(innerHtml);
    // Noto Sans matches the font already used for the Linux/wkhtmltopdf PDF path. The Google
    // Fonts link only benefits browser-based renderers (PDF); Word (DOC/DOCX) can't fetch web
    // fonts, so Arial is kept as the fallback for whoever doesn't have Noto Sans installed.
    const fontStack = "'Noto Sans', Arial, sans-serif";
    return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8">
<meta http-equiv="Content-Type" content="text/html; charset=utf-8">
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap" rel="stylesheet">
<style>body { font-family: ${fontStack}; }</style>
</head>
<body style="font-family:${fontStack};">
<div style="font-family:${fontStack};">
${cleanedHtml}
</div>
</body>
</html>`;
  }

  private removeFontFamilyFromHtml(html: string): string {
    let cleaned = html.replace(/font-family\s*:\s*([^;"]*(?:"[^"]*"[^;"]*)*);?/gi, '');
    cleaned = cleaned.replace(/;;/g, ';');
    cleaned = cleaned.replace(/style\s*=\s*"[;\s]*"/g, '');
    cleaned = cleaned.replace(/style\s*=\s*'[;\s]*'/g, '');
    return cleaned;
  }

  private combinedHtml(htmlChunks: string[]): string {
    const separator = `
  <hr style="border:1px solid #000; margin:20px 0;" />
  <div style="page-break-after: always;"></div>
`;

    return htmlChunks.join(separator);
  }

  getTooltipMessage(data: ArticleDetail) {
    if (data) {
      if (data.status == 2) {
        return "Published on " + this.formatDateUsingPipe(data.publisheddate);
        //"\nDraft - Last Updated on " + this.formatDate(data.updateddate);
      } else if (data.status == 5) {
        return "Scheduled on " + this.formatDateUsingPipe(data.scheduleddate);
      }
      else {
        if (data.updateddate && data.updateddate != "0001-01-01T00:00:00") {
          return "Last Updated on " + this.formatDateUsingPipe(data.updateddate);
        }
        else {
          return "Last Updated on " + this.formatDateUsingPipe(data.createddate);
        }
      }
    }
    return "";
  }

  formatDateUsingPipe(date: string | Date): string | null {
    return this.datePipe.transform(date, 'MMM d, y');
  }

}
